export const calcMargin = (w) => {
  if (w > 2000) return 288;
  if (w > 1900) return 256;
  if (w > 1800) return 192;
  if (w > 1700) return 128;
  if (w > 1600) return 96;
  if (w > 1500) return 32;
  if (w > 1400) return 16;
  if (w > 1350) return 8;
  if (w > 1300) return 4;
  return 0;
};

export const copyToClipboard = async (text) => {
  if (!text) return;
  if (navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.style.position = "fixed";
  ta.style.left = "-9999px";
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  try {
    document.execCommand("copy");
  } finally {
    document.body.removeChild(ta);
  }
};

export const tileCardStyle = (t) => ({
  width: "100%",
  textAlign: "left",
  borderRadius: 12,
  padding: 20,
  background: t.cardBg,
  border: `1px solid ${t.cardBorder}`,
  boxShadow: t.cardShadow,
  cursor: "pointer",
  transition: "all 0.2s ease",
  display: "block",
});

export const tileHoverHandlers = (t) => ({
  onMouseEnter: (e) => {
    e.currentTarget.style.background = t.cardHoverBg;
    e.currentTarget.style.borderColor = t.cardHoverBorder;
    e.currentTarget.style.boxShadow = t.cardHoverShadow;
    e.currentTarget.style.transform = "translateY(-1px)";
  },
  onMouseLeave: (e) => {
    e.currentTarget.style.background = t.cardBg;
    e.currentTarget.style.borderColor = t.cardBorder;
    e.currentTarget.style.boxShadow = t.cardShadow;
    e.currentTarget.style.transform = "translateY(0)";
  },
});
